// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MailOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m2.251 5.899 8.598 7.51a1.75 1.75 0 0 0 2.302 0l8.598-7.51c.081.191.126.401.126.622v10.958c0 .88-.716 1.596-1.595 1.596H3.72c-.88 0-1.595-.716-1.595-1.596V6.521c0-.22.045-.43.126-.622Zm.66-.752c.237-.14.514-.222.81-.222H20.28c.295 0 .572.081.81.222l-8.597 7.508a.75.75 0 0 1-.986 0L2.91 5.147Z"
			fill="#fff"
		/>
	</svg>
);
export default MailOutline;
